/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://hk.news.yahoo.com/%E9%A6%99%E6%B8%AF%E9%A6%AC%E8%8E%8E%E6%B4%A9%E5%AE%A2%E6%88%B6%E8%B3%87%E6%96%99-%E5%8C%85%E6%8B%AC%E5%A7%93%E5%90%8D%E3%80%81%E9%9B%BB%E9%83%B5%E3%80%81%E9%9B%BB%E8%A9%B1%E7%AD%89-%E7%84%A1%E5%9B%9E%E8%A6%86%E7%A7%81%E9%9A%B1%E5%85%AC%E7%BD%B2%E6%9F%A5%E8%A9%A2%EF%B8%B1yahoo-092442343.html?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAANDKJLRk8K8fAGJlNlwFKK_2xFTwzJcyYj6GpXq6I28HVoOH7m99TIIsd83UMvjL5wPqAKytSO63gy9nvVxLbRvg1Y7UFsRfJsUssQ4fuuRh0_nUeN4KCIh_5YScXz2J0RUbPyFJt42FAJ71jMTZ6x6Bg-veUpKMQhD2je6eJwF7'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open('https://www.wepro180.com/231017_ballet/');
        }}
        className="source2"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/940324/%E9%BB%91%E5%AE%A2%E5%85%A5%E4%BE%B5%E6%95%B8%E7%A2%BC%E6%B8%AF-%E6%9A%97%E7%B6%B2%E5%8F%AF%E6%9F%A5%E5%A4%96%E6%B4%A9%E5%93%A1%E5%B7%A5%E8%96%AA%E9%87%91%E5%B1%A5%E6%AD%B7%E8%A1%A8-%E5%B0%88%E5%AE%B6%E6%89%B9%E4%BF%9D%E5%AE%89%E6%84%8F%E8%AD%98%E4%BD%8E'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open('https://www.wepro180.com/231017_ballet/');
        }}
        className="source2"
      />
    </div>
  </>
);

export default Components004;
